import React, { useEffect, useState } from 'react';
export const LoadingProgress: React.FC = () => {
  const [progress, setProgress] = useState(0);
  const [currentStep, setCurrentStep] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 95) return prev;
        const increment = Math.random() * 8 + 6;
        const newProgress = Math.min(prev + increment, 95);

        // Update current step based on progress
        if (newProgress >= 80) setCurrentStep(4);else if (newProgress >= 60) setCurrentStep(3);else if (newProgress >= 40) setCurrentStep(2);else if (newProgress >= 20) setCurrentStep(1);else setCurrentStep(0);
        return newProgress;
      });
    }, 600);
    return () => clearInterval(interval);
  }, []);
  const getStatusText = () => {
    if (progress < 20) return 'Initializing system...';
    if (progress < 40) return 'Loading core modules...';
    if (progress < 60) return 'Setting up workspace...';
    if (progress < 80) return 'Preparing interface...';
    if (progress < 95) return 'Finalizing setup...';
    return 'Almost ready...';
  };
  const steps = [{
    label: 'Initialize',
    threshold: 0
  }, {
    label: 'Load Core',
    threshold: 25
  }, {
    label: 'Setup',
    threshold: 50
  }, {
    label: 'Interface',
    threshold: 75
  }, {
    label: 'Finalize',
    threshold: 100
  }];
  return <div className="w-full max-w-lg">
      {/* Enhanced progress bar with gradient and glow */}
      <div className="relative mb-6">
        <div className="h-3 bg-slate-200/60 rounded-full overflow-hidden shadow-inner">
          <div className="h-full bg-gradient-to-r from-purple-500 via-violet-500 to-indigo-500 rounded-full transition-all duration-1000 ease-out relative overflow-hidden" style={{
          width: `${progress}%`
        }}>
            {/* Animated shine effect */}
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/40 to-transparent animate-pulse" style={{
            animationDuration: '2s'
          }} />
            
            {/* Moving highlight */}
            <div className="absolute top-0 left-0 h-full w-8 bg-gradient-to-r from-transparent via-white/60 to-transparent animate-pulse transform -skew-x-12" style={{
            animationDuration: '3s',
            transform: `translateX(${progress * 4}px) skewX(-12deg)`
          }} />
          </div>
        </div>
        
        {/* Progress glow effect */}
        <div className="absolute top-0 h-3 bg-gradient-to-r from-purple-400/50 to-violet-400/50 rounded-full blur-sm transition-all duration-1000 ease-out" style={{
        width: `${progress}%`
      }} />
      </div>
      
      {/* Progress info with enhanced styling */}
      <div className="flex justify-between items-center mb-6">
        <span className="text-slate-600 text-sm font-medium animate-pulse">
          {getStatusText()}
        </span>
        <span className="font-mono text-purple-600 text-sm font-bold bg-purple-50 px-3 py-1 rounded-full">
          {Math.round(progress)}%
        </span>
      </div>
      
      {/* Interactive step indicators */}
      
    </div>;
};